const company = {
  name: 'ESAI Energy',
  legalName: 'ESAI Energy LLC',
  address: '300 Ballardvale Road, Suite 114, Andover, MA 01810',
  phone: '978-482-0900',
  links: {
    privacyPolicy: { label: 'Privacy Policy', url: 'https://www.esaienergy.com/privacy-policy', target: '_blank' },
    cyberSecurity: { label: 'Cybersecurity Policy', url: 'https://www.esaienergy.com/privacy-policy', target: '_blank' },
  },
};

export default company;
